import { connect, QuizSession } from '@instructure/quiz-core';
import { TakeHeader as TakeHeaderPresenter } from './presenter';
function mapStateToProps(state, ownProps) {
  var quizSessionId = ownProps.quizSessionId;
  var quizSession = QuizSession.create(state.getIn(['quizSessions', quizSessionId]));
  return {
    quiz: quizSession.getQuiz()
  };
}
export var TakeHeader = connect(mapStateToProps, {})(TakeHeaderPresenter);
export default TakeHeader;